/**
 * Browser polyfills and data layer initialization
 */
export const initPolyfills = () => {
    // IE11 polyfill
    if (!String.prototype.startsWith) {
        Object.defineProperty(String.prototype, 'startsWith', {
            value: function(search, rawPos) {
                var pos = rawPos > 0 ? rawPos|0 : 0;
                return this.substring(pos, pos + search.length) === search;
            }
        });
    }

    // Initialize digital data layer if it doesn't exist
    window.digitalData = window.digitalData || [];
};
